import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileComponent } from './pages/profile/profile.component';
import { JobsComponent } from './pages/jobs/jobs.component';
import { JobComponent } from './pages/job/job.component';
import { LogsComponent } from './pages/logs/logs.component';
import { LogComponent } from './pages/log/log.component';
import { MaterialsComponent } from './pages/materials/materials.component';
import { MaterialComponent } from './pages/material/material.component';
import { MessagesComponent } from './pages/messages/messages.component';
import { GeometryComponent } from './pages/geometry/geometry.component';
import { UsersComponent } from './pages/users/users.component';
import { UserComponent } from './pages/user/user.component';
import { OrganisationsComponent } from './pages/organisations/organisations.component';
import { OrgComponent } from './pages/org/org.component';
import { ClustersComponent } from './pages/clusters/clusters.component';
import { ErrorComponent } from './pages/error/error.component';
import { FmedaComponent } from './pages/fmeda/fmeda.component';
import { FmedaPdfPopoutComponent } from './pages/fmeda/fmeda-pdf-popout.component';
import { AppSelectionComponent } from './pages/app-selection/app-selection.component';
import { FmedaLandingComponent } from './pages/fmeda-landing/fmeda-landing.component';
import { MotortwinLandingComponent } from './pages/motortwin-landing/motortwin-landing.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { ToolAccessGuard } from './guards/tool-access.guard';
import { AuthGuard } from '@auth0/auth0-angular';

const routes: Routes = [
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'motortwin',
    component: MotortwinLandingComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'jobs',
    component: JobsComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'jobs/:fetch_type',
    component: JobsComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'job/:id',
    component: JobComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'logs',
    component: LogsComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'log/:id',
    component: LogComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'materials',
    component: MaterialsComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'material/:id',
    component: MaterialComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'messages',
    component: MessagesComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'geometry/:id',
    component: GeometryComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'user/:id',
    component: UserComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'organisations',
    component: OrganisationsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'org/:id',
    component: OrgComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'clusters',
    component: ClustersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'fmeda',
    component: FmedaLandingComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'fmeda' },
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'fmeda' },
  },
  {
    path: 'fmeda-workspace',
    component: FmedaComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'fmeda' },
  },
  {
    path: 'fmeda-pdf',
    component: FmedaPdfPopoutComponent,
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'fmeda' },
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: '',
    component: AppSelectionComponent,
    canActivate: [AuthGuard],
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
